import classNames from 'classnames';
import NavbarDual from 'components/navbars/navbar-dual/NavbarDual';
import NavbarTopHorizontal from 'components/navbars/navbar-horizontal/NavbarTopHorizontal';
import NavbarTopDefault from 'components/navbars/navbar-top/NavbarTopDefault';
import NavbarVertical from 'components/navbars/navbar-vertical/NavbarVertical';
import { useAppContext } from 'providers/AppProvider';
import { useMainLayoutContext } from 'providers/MainLayoutProvider';
import { Container } from 'react-bootstrap';
import { Navigate, Outlet } from 'react-router-dom';
import Loader from 'components/base/Loader';
import useAuth from 'hooks/useAuth';

const MainLayout = () => {
  const {
    config: { navbarPosition }
  } = useAppContext();

  const { contentClass } = useMainLayoutContext();

  const { isLoading, isValidAuth } = useAuth();

  return isValidAuth ? (
    isLoading ? (
      <Loader />
    ) : (
      <Container fluid className="px-0">
        {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
          <NavbarVertical />
        )}
        {navbarPosition === 'vertical' && <NavbarTopDefault />}
        {(navbarPosition === 'horizontal' || navbarPosition === 'combo') && (
          <NavbarTopHorizontal />
        )}
        {navbarPosition === 'dual' && <NavbarDual />}

        <div className={classNames(contentClass, 'content')}>
          <Outlet />
        </div>
      </Container>
    )
  ) : (
    <Navigate to="/" />
  );
};

export default MainLayout;
